import React from "react";
import { Button, Stepper as MuiStepper, Step, StepLabel, LinearProgress, Box } from "@mui/material";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Stepper = ({
  steps,
  currentStep, // Recibe el paso actual como prop
  onNext,
  onPrevious,
  onSubmit,
  formValues,
  formErrors,
  formTouched,
  showProgressBar,
  highlightErrorStep,
  metadata
}) => {
  const StepComponent = steps[currentStep]?.component; // Componente del paso actual



  return (
    <Box>
      {/* Barra de progreso */}
      {showProgressBar && (
        <Box mb={3}>
          <LinearProgress
            variant="determinate"
            value={((currentStep + 1) / steps.length) * 100} // Calcular progreso dinámico
          />
        </Box>
      )}

      {/* Stepper */}
      <MuiStepper activeStep={currentStep} alternativeLabel>
        {steps.map((step, index) => (
          <Step key={index} completed={formErrors && !formErrors[step.label]}>
            <StepLabel >{step.label}</StepLabel>
          </Step>
        ))}
      </MuiStepper>

      {/* Componente del paso actual */}
      <Box mt={2}>{StepComponent && React.createElement(StepComponent,{metadata,       formValues,
            formErrors,
            formTouched,})}</Box>

      {/* Botones de navegación */}
      <Box mt={2} display="flex" justifyContent="space-between">
        <Button
          variant="contained"
          onClick={onPrevious}
          disabled={currentStep === 0} // Deshabilitar si es el primer paso
        >
          Anterior
        </Button>

        {currentStep === steps.length - 1 ? (
          <Button onClick={onSubmit} variant="contained" color="primary">
            Enviar
          </Button>
        ) : (
          <Button variant="contained" color="primary" onClick={onNext}>
            Siguiente
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default Stepper;
